var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInternalNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 1.33334H5.33334C2.66668 1.33334 1.33334 2.66668 1.33334 5.33334V14C1.33334 14.3667 1.63334 14.6667 2.00001 14.6667H10.6667C13.3333 14.6667 14.6667 13.3333 14.6667 10.6667V5.33334C14.6667 2.66668 13.3333 1.33334 10.6667 1.33334ZM9.33334 10.1667H4.66668C4.39334 10.1667 4.16668 9.94001 4.16668 9.66668C4.16668 9.39334 4.39334 9.16668 4.66668 9.16668H9.33334C9.60668 9.16668 9.83334 9.39334 9.83334 9.66668C9.83334 9.94001 9.60668 10.1667 9.33334 10.1667ZM11.3333 6.83334H4.66668C4.39334 6.83334 4.16668 6.60668 4.16668 6.33334C4.16668 6.06001 4.39334 5.83334 4.66668 5.83334H11.3333C11.6067 5.83334 11.8333 6.06001 11.8333 6.33334C11.8333 6.60668 11.6067 6.83334 11.3333 6.83334Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalNote);
export default __webpack_public_path__ + "static/media/internalNote.b67aab110ed1503c16816478cde412f2.svg";
export { ForwardRef as ReactComponent };